<template>
    <div class="home_page" :style="{ paddingTop: dataSet.isShowingPWA ? '120px' : '55px' }">
        <span id="top-of-home-page"></span>
        <div v-for="(item, index) in dataSet.componentList" :key="index">
            <MainHeader @intallPWA="installApp" @isClosedPWA="isClosedPWA" :listGameData="dataSet.groupList"
                @openSidebar="openSidebar" @showPWA="setShowPWA" v-if="isComponentVisible(item, 'header')"
                :itemData="item" @goToDeposit="goToDeposit" @goToGamePanel="goToGamePannel" />
            <CarousalCard v-if="isComponentVisible(item, 'banners')" :itemData="item" />
            <BannerCard v-if="isComponentVisible(item, 'notice')" :itemData="item" />
            <NoticeBar v-if="isComponentVisible(item, 'newsBar')" :itemData="item" @goToGameSearch="goToGameSearch" />
            <div v-if="isComponentVisible(item, 'gameGroups')">
                <GroupList :ref="el => setGroupListRef(el)" :listData="dataSet.groupList" :isShowingPWA="dataSet.isShowingPWA"
                    @goToGamePanel="goToGamePannel" :itemData="item" />
                <div class="home_game_panel" v-for="(subitem, index) in dataSet.groupList" :key="index">
                    <GamePanel v-if="!showGroupGames" :groupImage="subitem.customIcon" :groupName="subitem.showName"
                        @goGamePannel="goToGamePannel(subitem)" :gameList="subitem.games" :itemData="item"
                        @showGames="showGames(subitem)" :itemIndex="index" />
                </div>
            </div>
            <DownloadPanel v-if="isComponentVisible(item, 'AppDownload')" :itemData="item" />
            <MediaSection v-if="isComponentVisible(item, 'shareMedia')" :itemData="item" />
            <FooterText v-if="isComponentVisible(item, 'footerText')" :itemData="item" />
            <MainFooter v-if="isComponentVisible(item, 'footer')" @goToProfile="openProfilePopup" :itemData="item"
                @profileClose="closeProfilePoup" :ref="setFooterRef" @openPWA="openPWAPopup" :activeFooter="0" />
            <ContactService v-if="isComponentVisible(item, 'contactService')" :itemData="item" />
            <ProviderCard v-if="isComponentVisible(item, 'providers')" :itemData="item" />
            <CopyRightBar v-if="isComponentVisible(item, 'copyrightText')" :itemData="item" />
        </div>
    </div>

    <FloatButton @openPWA="openPWAPopup" @handleShowTreasurePopup="handleShowTreasurePopup"  @openMisteryBoxPopup="openMisteryBoxPopup"/>
    <FloatButton2 />
    <!-- Popup -->
    <GamePopup ref="gamePopupRef" @resetSelectedGroup="resetSelectedGroup" @goToProfile="openProfilePopup" />
    <SideNavbar ref="sideNavbarRef" :listGameData="dataSet.groupList" @intallPWA="installApp"
        @openContactPopup="goToContactPage" @goToGamePanelSlide="goToGamePannel" @openPWA="openPWAPopup"/>
    <PwaAntiBlockingPopup ref="pwaPopupRef" />
    <PwaStatusPopup ref="pwaPopupStatusRef" />
    <MisteryBoxView ref="misteryBoxRef"/>
    <ClaimListPopup
        v-if="userStore.allActivityBonusPopup && userStore.claimActivityList.length > 0 && !userStore.pwaShowing && userStore.isInHome"
        ref="claimListPopupRef" @handleShowTreasurePopup="handleShowTreasurePopup"
        @resetShowTreasurePopup="resetShowTreasurePopup" @open-mistery-box-popup="openMisteryBoxPopup"/>

</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import BannerCard from './components/bannerCard.vue'
import CarousalCard from './components/carousalCard.vue'
import NoticeBar from './components/noticeBar.vue'
import GroupList from './components/groupList.vue'
import GamePanel from './components/gamePanel.vue'
import ContactService from './components/contactService.vue'
import FooterText from './components/footerText.vue'
import DownloadPanel from './components/downloadPanel.vue'
import MediaSection from './components/mediaSection.vue'
import FloatButton from './components/floatButton.vue'
import { getGameSpecialCategories, HomeData } from '@/view/home/supportScript'
import MainHeader from '../components/common/mainHeader.vue'
import MainFooter from '../components/common/mainFooter.vue'
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue'
import { playClickSound } from '@/utils/media'
import ClaimListPopup from '../components/common/claimListPopup.vue'
import { useUserStore } from '@/stores/user'
import FloatButton2 from './components/floatButton2.vue'
import SideNavbar from '../components/sideNav/sideNavbar.vue'
import { useRouter } from 'vue-router'
import ProviderCard from './components/providerCard.vue'
import CopyRightBar from './components/copyRightBar.vue'
import GamePopup from '@/view/game/gamePopup.vue'
import { useThemeStore } from '@/stores/theme'
import { useGameStore } from '@/stores/games'
import MisteryBoxView from '@/view/misteryBox/misteryBoxView.vue'
const userStore = useUserStore()
const router = useRouter()
const themeStore = useThemeStore()
const gameStore = useGameStore()
const gamePopupRef = ref()
const profilePopupRef = ref()
const pwaPopupRef = ref()
const misteryBoxRef = ref()
const pwaPopupStatusRef = ref()
const showGroupGames = ref(false)
const groupListRef = ref()
const sideNavbarRef = ref()
const showPop = ref()
const props = defineProps<{
    dataSet: HomeData
}>()

const emits = defineEmits(['setFooterRef', 'goToGamePannel', 'openProfilePopup', 'isComponentVisible', 'installApp', 'isClosedPWA', 'setShowPWA', 'openPWAPopup', 'setGroupListRef', 'goToDeposit', 'handleShowTreasurePopup', 'resetShowTreasurePopup', 'resetSelectedGroup', 'goToGameSearch'])

const setFooterRef = (el: any) => {
    emits('setFooterRef', el)
};
const showGames = (item: any) => {
    groupListRef.value.setActiopFunGroup(item)

    const topAnchor = document.getElementById('page-top-anchor');
    if (topAnchor) {
        topAnchor.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

const openProfilePopup = () => {
    emits('openProfilePopup')
}

const closeProfilePoup = () => {
    profilePopupRef.value.close()
}
const goToGamePannel = (data: any) => {
    sideNavbarRef.value.closeSidebar()
    if (data.name == 'games.favorite') {
        router.push({
            path: '/searchGames',
            query: { tab: '4' }
        })
    } else if (data.name == 'Hot') {
        router.push({
            path: '/searchGames',
            query: { tab: '2' }
        })
    } else {
        emits('goToGamePannel', data)
    }

}
const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
}
const openMisteryBoxPopup = () => {
    misteryBoxRef.value.open()
}
const showGameList = (value: any) => {
    showGroupGames.value = value
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};

const installApp = async () => {
    emits('installApp')
}
const isClosedPWA = async (value: any) => {
    emits('isClosedPWA', value)
}
const setShowPWA = async (value: any) => {
    emits('setShowPWA', value)
}

const openPWAPopup = () => {
    emits('openPWAPopup')
}
const resetSelectedGroup = () => {
    emits('resetSelectedGroup')
}
const setGroupListRef = (el: any) => {
    emits('setGroupListRef', el)
    groupListRef.value = el
}

const gamePoupOpen = (id: number) => {
    gamePopupRef.value.open(id);
}

const profilePoupOpen = (list: any) => {
    profilePopupRef.value.open(list);
}

const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}

const goToContactPage = () => {
    router.push('/sd-message')
}

const goToDeposit = () => {
    emits('goToDeposit')
}

const openSidebar = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return false; }
    playClickSound()
    sideNavbarRef.value.openSidebar()
}

const goToGameSearch = () => {
    emits('goToGameSearch')
}

const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
const getGameTabData = async () => {
    const { favoriteGameList, hotGameList, recentGameList } = await getGameSpecialCategories()
    gameStore.setHotGames(hotGameList)
}
onMounted(() => {
    showPop.value = false
    setTimeout(() => {
        showPop.value = true
    }, 2000)
    getGameTabData()
})
defineExpose({
    gamePoupOpen,
    profilePoupOpen,
    pwaStatusPoupOpen,
    pwaPoupOpen
})
</script>
<style scoped>
.home_page {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 0px 50px;
}

.home_page::-webkit-scrollbar {
    display: none;
}
</style>